// extracted by mini-css-extract-plugin
module.exports = {"priceContainer":"PriceFilter_priceContainer__U_AVg"};